import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import Select from '../../../../../components/forms/Select'
import NetworkDto from '../../../../../referencial/components/network/dto/NetworkDto'
import { SHOW_SANDRE_CODE } from 'account/constants/AccountSettingsConstants'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'

const OperationNetworkModal = ({
    isOpen = false,
    onValidate = () => {},
    onClose = () => { },
    selectedNetwork = {},
    networks = [],
}) => {
    const [network, setNetwork] = useState(selectedNetwork)
    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)
    return (
        <Dialog
            fullWidth
            maxWidth='sm'
            open={isOpen}
            onClose={() => {}}
        >
            <DialogTitle>{i18n.network}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid size={12}>
                        <Select
                            options={ networks }
                            value={ network }
                            keyLabel={showSandreCode ? 'nameWithSandre' : 'name'}
                            keyValue='sandreCode'
                            onChange={ setNetwork }
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant='outlined' >
                    {i18n.cancel}
                </Button>
                <Button onClick={() => onValidate(network) } variant='contained' color='primary'>
                    {i18n.save}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

OperationNetworkModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onValidate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onReject: PropTypes.func,
    selectedNetwork: PropTypes.string,
    networks: PropTypes.arrayOf(PropTypes.instanceOf(NetworkDto)),
}

export default OperationNetworkModal